import { ApiOrganisationCurrencyEnum } from '../api';

export const symbolOfCurrency: { [key: string]: string } = {
  [ApiOrganisationCurrencyEnum.EUR]: '€',
  [ApiOrganisationCurrencyEnum.GBP]: '£',
  [ApiOrganisationCurrencyEnum.USD]: '$',
  [ApiOrganisationCurrencyEnum.KES]: 'KSh',
  [ApiOrganisationCurrencyEnum.UGX]: 'USh',
  [ApiOrganisationCurrencyEnum.ALL]: 'L',
  [ApiOrganisationCurrencyEnum.KZT]: '₸',
  [ApiOrganisationCurrencyEnum.HKD]: 'HK$',
  [ApiOrganisationCurrencyEnum.BRL]: 'R$',
  [ApiOrganisationCurrencyEnum.ZMW]: 'K',
};
